<template>
  <div class="myTable">
    <div class="searchNav">
      <div class="search-form">
        <div class="search-items">
          <div class="search-item">
            <span class="label">认证状态：</span>
            <el-select v-model="searchInfo.status" clearable @change="search" placeholder="请选择">
              <el-option v-for="(item, i) in statusList" :key="i" :label="item.value" :value="item.status"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">店铺名称：</span>
            <el-input v-model="searchInfo.shopName" clearable placeholder="请输入"></el-input>
          </div>
          <div class="search-item">
            <span class="label">联系电话：</span>
            <el-input v-model="searchInfo.phone" clearable placeholder="请输入"></el-input>
          </div>
          <div class="search-item">
            <span class="label">城&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;市：</span>
            <el-input v-model="searchInfo.city" clearable placeholder="请输入"></el-input>
          </div>
          <div class="search-item">
            <span class="label">用户名称：</span>
            <el-input v-model="searchInfo.nickname" clearable placeholder="请输入"></el-input>
          </div>
          <div class="search-item">
            <span class="label">店铺地址：</span>
            <el-input v-model="searchInfo.address" clearable placeholder="请输入"></el-input>
          </div>
          <div class="search-item date-picker">
            <span class="label">创建时间：</span>
            <el-date-picker v-model="searchDateArr" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="search-btn">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </div>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" :row-class-name="tableRowClassName"  max-height="600px"  @row-dblclick="handleRowDblClick" >
        <el-table-column
                type="index"
                width="50">
        </el-table-column>
        <el-table-column prop="shopPhotos" label="店铺认证" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.shopPhotos" style="position: relative; display: inline-block;">
              <el-image
                      :src="parseImages(scope.row.shopPhotos)[0]"
                      :preview-src-list="parseImages(scope.row.shopPhotos)"
                      style="width: 60px; height: 60px; border-radius: 4px;"
                      fit="cover"
              />
              <span v-if="parseImages(scope.row.shopPhotos).length > 1"
                    style="position: absolute; bottom: 2px; right: 2px; background: rgba(0,0,0,0.6); color: #fff; padding: 0 4px; font-size: 10px; border-radius: 2px;">
                {{ parseImages(scope.row.shopPhotos).length }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="shopName" label="店铺名称" width="180" ></el-table-column>
        <el-table-column prop="nickname" label="用户名称" width="80">
          <template slot-scope="scope">
            <el-button type="text" @click="showUserDetail(scope.row)">{{ scope.row.nickname }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="联系电话" width="120">
          <template slot-scope="scope">
            {{ scope.row.phone }}
          </template>
        </el-table-column>
        <el-table-column prop="city" label="城市" width="80" ></el-table-column>
        <el-table-column prop="address" label="地址" width="120" ></el-table-column>
        <el-table-column prop="detailAddress" label="详细地址" width="200"  ></el-table-column>
        <el-table-column prop="services" label="服务项目" width="150" ></el-table-column>
        <el-table-column prop="status" label="认证状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType1(scope.row.status)">
              {{ scope.row.status | showCertificationStatus }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="businessStartTime" label="营业开始" width="100">
          <template slot-scope="scope">
            {{ scope.row.businessStartTime || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="businessEndTime" label="营业结束" width="100">
          <template slot-scope="scope">
            {{ scope.row.businessEndTime || '--' }}
          </template>
        </el-table-column>

        <el-table-column prop="avgRating" label="评分" width="80">
          <template slot-scope="scope">
            <span style="font-size: 14px;font-weight: 500;color: #f39c12;display: block; text-align: center;">{{ scope.row.avgRating || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ratingCount" label="评价数" width="80">
          <template slot-scope="scope">
            <span style="display: block; text-align: center;">{{ scope.row.ratingCount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDateTime }}
          </template>
        </el-table-column>
        <el-table-column prop="auditTime" label="审核时间" width="160">
          <template slot-scope="scope">
            {{ scope.row.auditTime | formatDateTime }}
          </template>
        </el-table-column>




        <el-table-column
                fixed="right"
                label="操作"
                width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="moreInfo(scope.row)">详情</el-button>
            <el-button type="text" size="small" @click="auditShop(scope.row)">审核</el-button>
          </template>
        </el-table-column>
        <!-- 自定义空数据展示 -->
        <template slot="empty">
          <div class="empty-container">
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>

    <div>
      <el-dialog
              title="详情"
              :visible.sync="moreInfoDialogVisible"
              width="50%"
              :before-close="handleClose"
              center>
        <div>
          <div>
            <div class="group_27" style="display: flex;">
              <div class="group_28"></div>
              <div class="text_93">店铺认证信息</div>
            </div>
            <div  style="margin-left: 15px;">
              <el-form label-width="120px">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="用户名称：">
                      {{addInfo.nickname}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="店铺名称：">
                      {{addInfo.shopName}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="联系电话：">
                      {{addInfo.phone}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="城市：">
                      {{addInfo.city || '--'}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="店铺地址：">
                      {{addInfo.address}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="详细地址：">
                      {{addInfo.detailAddress}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="服务项目：">
                      {{addInfo.services}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20" v-if="addInfo.otherServices">
                  <el-col :span="24">
                    <el-form-item label="其他服务：">
                      {{addInfo.otherServices}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="营业开始：">
                      {{addInfo.businessStartTime || '--'}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="营业结束：">
                      {{addInfo.businessEndTime || '--'}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="认证状态：">
                      {{addInfo.status | showCertificationStatus}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="平均评分：">
                      {{addInfo.avgRating || 0}} 分 ({{addInfo.ratingCount || 0}}条评价)
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="创建时间：">
                      {{addInfo.createTime | formatDateTime}}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="审核时间：">
                      {{addInfo.auditTime | formatDateTime}}
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            
            <!-- 资质照片区域 -->
            <div class="photo-section" v-if="addInfo.businessLicenseUrl || addInfo.shopPhotos">
              <div class="photo-block" v-if="addInfo.businessLicenseUrl">
                <div class="photo-block-title">营业执照</div>
                <div class="photo-block-content">
                  <el-image
                    class="photo-image"
                    :src="addInfo.businessLicenseUrl"
                    fit="cover"
                    :preview-src-list="[addInfo.businessLicenseUrl]">
                  </el-image>
                </div>
              </div>
              <div class="photo-block" v-if="addInfo.shopPhotos">
                <div class="photo-block-title">门店照片</div>
                <div class="photo-block-content photo-list">
                  <el-image
                    v-for="(photo, index) in getShopPhotos(addInfo.shopPhotos)"
                    :key="index"
                    class="photo-image"
                    :src="photo"
                    fit="cover"
                    :preview-src-list="getShopPhotos(addInfo.shopPhotos)">
                  </el-image>
                </div>
              </div>
            </div>
          </div>
        </div>

      </el-dialog>
    </div>

    <!-- 审核弹窗 -->
    <div>
      <el-dialog
        title="店铺认证审核"
        :visible.sync="auditDialogVisible"
        width="500px"
        :before-close="handleAuditClose">
        <el-form :model="auditForm" :rules="auditRules" ref="auditForm" label-width="100px">
          <el-form-item label="审核状态" prop="status">
            <el-radio-group v-model="auditForm.status">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">拒绝</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审核原因" prop="reason">
            <el-input
              v-model="auditForm.reason"
              type="textarea"
              :rows="4"
              placeholder="请输入审核原因（未通过时必填）"
              maxlength="200"
              show-word-limit>
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="auditDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitAudit" :loading="auditSubmitting">提交</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 用户详情对话框 -->
    <user-detail-dialog
      :visible.sync="userDetailVisible"
      :user-id="selectedUserId">
    </user-detail-dialog>

  </div>

</template>

<script>
  import {axios} from "../../config/axios";
  import UserDetailDialog from '../common/user-detail-dialog.vue';

  export default {
    name: "shop-certification-stat",
    components: {
      UserDetailDialog
    },
    data () {
      const vm = this; // 保存组件实例的引用
      return {
        dialogTitle:'店铺认证详情',
        total:1,
        tableData: [],
        searchDateArr: [],
        loading: false,
        tableLoading: false,
        moreInfoDialogVisible: false,
        auditDialogVisible: false,
        auditSubmitting: false,
        currentPage:1,
        addInfo:{},
        // 审核表单
        auditForm: {
          shopId: null,
          status: 1,
          reason: ''
        },
        // 用户详情弹窗
        userDetailVisible: false,
        selectedUserId: null,
        searchInfo:{
          shopName:'',
          phone:'',
          city:'',
          nickname:'',
          address:'',
          status:'',
          searchDate:'',
          pageNumber:1,
          pageSize:50,
        },
        statusList:[{"status":"0","value":"未审核"},{"status":"1","value":"审核通过"},{"status":"2","value":"审核拒绝"}],
        // 审核表单验证规则
        auditRules: {
          status: [
            { required: true, message: '请选择审核状态', trigger: 'change' }
          ],
          reason: [
            {
              validator: (rule, value, callback) => {
                if (vm.auditForm.status === 2 && !value) {
                  callback(new Error('未通过时必须填写审核原因'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ]
        },
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              //start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }]
        },

      }
    },
    watch: {
      'searchInfo.shopName'(newVal,oldVal){
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.phone'(newVal,oldVal){
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.city'(newVal,oldVal){
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchInfo.address'(newVal,oldVal){
        if ("" == newVal){
          this.pageInfo();
        }
      },
      'searchDateArr'(newVal){
        if (newVal === null){
          this.searchInfo.startDate = "";
          this.searchInfo.endDate = "";
          this.getVideoList();
        }
      },
    },
    created: function () {
      this.pageInfo();
    },
    methods:{
      // 显示用户详情
      showUserDetail(row) {
        this.selectedUserId = row.userId;
        this.userDetailVisible = true;
      },

      search(){
        this.pageInfo();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNumber = val ;
        this.pageInfo();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 0;
        this.searchInfo.pageSize = val ;
        this.pageInfo();
      },
      getStatusTagType1(status) {
        const typeMap = {
          2: 'warning',  // 未审核
          1: 'success',     // 草稿
          0: 'info'
        };
        return typeMap[status] || 'info';
      },

      // 解析图片URL（分号分隔）
      parseImages(coverImage) {
        if (!coverImage) return [];
        // 分号分隔，过滤空字符串
        let arr = coverImage.split(';').filter(img => img.trim());
        return arr;
      },
      // 审核店铺
      auditShop(row) {
        this.auditForm = {
          shopId: row.id,
          status: 1,
          reason: ''
        };
        this.auditDialogVisible = true;
      },
      // 提交审核
      submitAudit() {
        this.$refs.auditForm.validate((valid) => {
          if (valid) {
            this.auditSubmitting = true;

            axios.put(`/shop-certification/${this.auditForm.shopId}/audit`, null, {
              params: {
                status: this.auditForm.status,
                reason: this.auditForm.reason
              }
            }).then(result => {
              this.auditSubmitting = false;
              if (result.code === 200) {
                this.$message.success('审核成功');
                this.auditDialogVisible = false;
                this.pageInfo();
              } else {
                this.$message.error(result.message || '审核失败');
              }
            }).catch(err => {
              console.error(err);
              this.auditSubmitting = false;
              this.$message.error('网络异常，请重试');
            });
          }
        });
      },
      // 关闭审核弹窗
      handleAuditClose(done) {
        this.auditForm = {
          shopId: null,
          status: 1,
          reason: ''
        };
        if (this.$refs.auditForm) {
          this.$refs.auditForm.clearValidate();
        }
        done();
      },
      handleClose(done) {
        this.clearObj(this.addInfo); // 清空新增数据
        done();
      },
      moreInfo(obj){
        this.addInfo =JSON.parse(JSON.stringify(obj));
        this.moreInfoDialogVisible = true;
        //.getContactsLists(this.addInfo.id);
      },
      handleRowDblClick(row, column, event) {
        this.addInfo =JSON.parse(JSON.stringify(row));
        this.moreInfoDialogVisible = true;
        //this.getContactsLists(this.addInfo.id);
      },
      pageInfo(){
        if (this.searchDateArr && this.searchDateArr.length === 2) {
          this.searchInfo.startDate = this.searchDateArr[0];
          this.searchInfo.endDate = this.searchDateArr[1];
        }
        if (this.loading)  return; // 防止重复提交
        this.loading=true;
        axios.get('/shop-certification/list',{
          params: this.searchInfo
        }).then(result => {
          this.loading=false;
          if (result.code !== 200){
            console.log(result);
          }
          let page = result.data;

          this.total = page.total;
          this.tableData = page.list;
        }).catch(err => {
          console.log(err);
          this.loading=false;
        });
      },

      getShopPhotos(photos) {
        if (!photos) return [];
        return photos.split(';').filter(photo => photo.trim());
      },
    },filters: {
      showCertificationStatus(val){
        if (val == 0){
          return "未审核";
        }
        if (val == 1){
          return "审核通过";
        }
        if (val == 2){
          return "审核拒绝";
        }
        return "--"
      },
      formatDateTime(val) {
        if (!val) return '--';
        if (typeof val === 'string' && val.includes('T')) {
          return val.replace('T', ' ').substring(0, 19);
        }
        return val;
      }
    }
  }
</script>
<style lang="less" scoped>
  .addInfoStyle div{
    line-height: 4;
    .el-input{
      margin-right: 15px;
      width: 200px;
    }
  }
  /deep/ #contentStyle .el-form-item__content{
    margin-left:0 !important;
  }
  .connectTitleStyle{
    display: flex;
    justify-content: space-between;
    background: #f6f8fc;
    margin-left: 15px;
  }

  /deep/ #connectInfoStyle .el-table{
    .el-table__body-wrapper{
      height: auto; overflow-y: auto;
    }
  }

  .searchNav {
    padding: 16px 16px 0 16px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    align-items: flex-start;

    .search-form {
      flex: 1;
      padding-right: 16px;

      .search-items {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -8px;

        .search-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          min-width: fit-content;

          .label {
            white-space: nowrap;
            color: #606266;
            font-size: 12px;
          }

          .el-input {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          .el-select {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          &.date-picker {
            .el-date-editor {
              width: 280px !important;
              /deep/ .el-input__inner {
                height: 32px;
                line-height: 32px;
              }
            }
          }
        }
      }
    }

    .search-btn {
      padding-top: 0;
      .el-button {
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .searchNav {
      flex-direction: column;
      padding: 12px;

      .search-form {
        width: 100%;
        padding-right: 0;

        .search-items {
          .search-item {
            width: 100%;

            .el-input, .el-select, .el-date-editor {
              width: 100% !important;
            }
          }
        }
      }

      .search-btn {
        width: 100%;
        margin-top: 16px;
        justify-content: center;
      }
    }
  }
  /deep/ .el-date-editor .el-range-separator {
    color: #606266 !important;
  }

  .photo-section {
    margin: 20px 15px 0;
    padding-top: 16px;
    border-top: 1px dashed #e4e7ed;
  }

  .photo-block {
    margin-bottom: 20px;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .photo-block-title {
      font-size: 14px;
      color: #303133;
      font-weight: 500;
      margin-bottom: 12px;
      padding-left: 10px;
      border-left: 3px solid #409eff;
    }
    
    .photo-block-content {
      padding-left: 13px;
    }
  }

  .photo-image {
    width: 160px;
    height: 120px;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    cursor: pointer;
    transition: all 0.3s;
    
    &:hover {
      transform: scale(1.02);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
  }

  .photo-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }

</style>
